module.exports = __webpack_public_path__ + "static/Final_proposal_and_release_plan-7e65aee2f97c88699423b74b96bd938d.png";